import { keys } from '@core/Services/Analytics/keys'
import { trackEvent, trackKey } from '@core/Services/Analytics/track'

export const trackRaceReplayVideoLaunched = (replayLocation: string, replayAvailable: boolean) =>
  trackEvent(keys.raceReplayLaunched, {
    replayLocation: replayLocation,
    replayAvailable: replayAvailable,
  })

export const trackRaceReplayVideoFullScreen = (isFullScreen: boolean) =>
  trackEvent(keys.raceReplayFullScreen, { isFullScreen: isFullScreen })

export const trackRaceReplayVideoMute = (isMuted: boolean) =>
  trackEvent(keys.raceReplayMute, { isMuted: isMuted })

export const trackRaceReplayVideoClosed = () => trackKey(keys.raceReplayClosed)
